import { Button } from '@teamfoster/sdk/button';
import { addDays, addYears } from 'date-fns';

export const word = ['Consectetur', 'Lorem ipsum', 'Pellentesque', 'Adipisicing', 'Quasi'];

export const category = ['Workshop', 'Training', 'Tentoonstelling', 'Lezing', 'Audiotour', 'Doe het zelf'];

export const title = [
  'The quick brown fox jumps over the lazy dog',
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
  'Lipsum asmet',
  'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi omnis autem enim ratione',
  'Over the lazy dog',
  'The quick brown fox jumps.',
  'Lipsum asmet',
];

export const subtitle = ['The quick brown fox jumps.', 'Lipsum asmet', 'Over the lazy dog?'];

export const paragraph = [
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla nec odio nec nunc',
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris interdum pulvinar tellus ac commodo. Maecenas convallis sem metus, in volutpat arcu venenatis quis. Fusce consectetur tincidunt tincidunt. Nam dignissim ante ac justo dictum, at sagittis augue semper. Ut pellentesque facilisis mattis. Cras consequat, mauris maximus sagittis blandit, felis felis viverra magna, non convallis dui orci vel mi.',
  `Sed quis magna id ex sollicitudin euismod quis ut nunc. Nulla non finibus mauris. Aliquam pretium arcu non consectetur ultrices. In hac habitasse platea dictumst. Aliquam rhoncus velit et ipsum dapibus, non sollicitudin lorem aliquet. Etiam quis nunc congue, ornare orci a, mollis est. Morbi orci leo, cursus non ipsum sodales, pellentesque suscipit diam.

  Duis non ipsum at ante maximus volutpat. Phasellus egestas ipsum sit amet ante fermentum facilisis. Mauris at lobortis enim, a sodales dui. Nullam consequat, erat sed finibus feugiat, tortor eros semper tellus, vitae accumsan mi nulla vel est. Sed varius orci id tincidunt commodo. Praesent porttitor, ipsum eget luctus laoreet, nisl mi viverra orci, id dictum purus orci vel enim. Vivamus tincidunt, lectus in accumsan tincidunt, lacus quam euismod risus, sagittis ultrices orci dui ac ligula. Praesent hendrerit eu nunc id mollis.
  `,
  'Sed quis magna id ex sollicitudin euismod quis ut nunc. Nulla non finibus mauris. Aliquam pretium arcu non consectetur ultrices. In hac habitasse platea dictumst. Aliquam rhoncus velit et ipsum dapibus, non sollicitudin lorem aliquet. ',
  'Lorem ipsum dolor smit',
];

export const testButton: Button[] = [
  {
    url: '/contentblokken',
    routerLink: ['/', 'contentblokken'],
    text: 'Button routerlink',
  },
  {
    url: 'https://www.teamfoster.nl/',
    routerLink: null,
    text: 'Button url',
  },
];

export const wysiwyg = `
<p>
      Lorem ipsum dolor sit amet,
      <strong>consectetur</strong>
      adipiscing elit. Quisque eu ligula vitae augue ultrices sollicitudin. Cras dignissim ipsum turpis, quis posuere metus pulvinar sit
      amet. Morbi dictum mi in ultrices dignissim.
      <em>Etiam a tellus in orci luctus laoreet eu quis enim</em>
      . Curabitur ornare augue arcu. Vivamus ut orci dictum,
      <u>pellentesque</u>
      arcu eu, posuere velit.
      <a href="#">Curabitur gravida</a>
      purus elit, non feugiat tortor iaculis et. Vestibulum facilisis massa a bibendum semper. Nam non imperdiet est. Nam id tincidunt orci.
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <p>
      <app-content-accordeon></app-content-accordeon>
    </p>



    <h3>Heading 3</h3>
    <ol>
      <li>lakdsf</li>
      <li>asdf</li>
      <li>asdfklajsdfklj</li>
      <li>adsfkljalskdjf sdklafj lkasdj flka sjdflkaj sdflkajsdf lkasjdf</li>
    </ol>


    <app-content-accordeon></app-content-accordeon>

    <img src="https://www.teamfoster.nl/media/pexels-markus-spiske-192320.jpg" alt="Placeholder Image" />

    <p>
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <ul>
      <li>asdjklf</li>
      <li>asdfalksjdf</li>
      <li>asdf</li>
      <li>sdafkljasd;f</li>
    </ul>

    <p>
      <app-content-slider data-pseudo-content="Slider #1 - Speelgoed" id="1"></app-content-slider>
      <br>
    </p>

    <p>
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <blockquote>
      <p>dit is een citaat in de lopende content</p>
    </blockquote>

    <p>
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <table>
      <tbody>
        <tr>
          <td>asdf</td>
          <td>lkjdsfj</td>
          <td>lkjdslkj</td>
        </tr>
        <tr>
          <td>lksdjf</td>
          <td>lkjlkjdsflksdlkfj</td>
          <td>ldslfkj</td>
        </tr>
      </tbody>
    </table>

    <p>
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <table>
      <tbody>
        <tr>
          <td>fsa</td>
          <td>lkfdjs lkj</td>
          <td>lkj fdlksj&nbsp;</td>
          <td>lkj flkj</td>
          <td>&nbsp;lkjflkj</td>
          <td>lk jflk</td>
          <td>j flkj</td>
          <td>&nbsp;lkjf</td>
        </tr>
        <tr>
          <td>jfklsd jl</td>
          <td>kjf lk</td>
          <td>jwlkd jlkjf lkj</td>
          <td>lkjflk jsdlfkj</td>
          <td>
            Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh vitae posuere. Morbi sollicitudin, odio sit amet
            bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
            <br />
          </td>
          <td>jflkasj fk</td>
          <td>jlkfj slkdjf&nbsp;</td>
          <td>lkjd&nbsp;</td>
        </tr>
      </tbody>
    </table>

    <p>
      Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh vitae posuere. Morbi sollicitudin, odio sit amet
      bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>
`;

export const wysiwygPanels = `
<p>
  Lorem ipsum dolor sit amet,
  <strong>consectetur</strong>
  adipiscing elit. Quisque eu ligula vitae augue ultrices sollicitudin. Cras dignissim ipsum turpis, quis posuere metus pulvinar sit
  amet. Morbi dictum mi in ultrices dignissim.
  <em>Etiam a tellus in orci luctus laoreet eu quis enim</em>
  . Curabitur ornare augue arcu. Vivamus ut orci dictum,
  <u>pellentesque</u>
  arcu eu, posuere velit.
  <a href="#">Curabitur gravida</a>
  purus elit, non feugiat tortor iaculis et. Vestibulum facilisis massa a bibendum semper. Nam non imperdiet est. Nam id tincidunt orci.
  Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
  vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>

    <p>
  <app-content-accordeon></app-content-accordeon>
    </p>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="" data-color-name="Grijs (standaard)">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="primary" data-color-name="Groen">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="secondary" data-color-name="Paars">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="accent" data-color-name="Geel">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="danger" data-color-name="Melding gevaar (rood)">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="warning" data-color-name="Melding waarschuwing (oranje)">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

<app-content-panel data-component-title="Paneel" data-design-block="app-content-panel" datacolor="info" data-color-name="Melding informatief (blauw)">
  <div class="content"><p><strong>Historisch Café: de ontmoetingsplek voor iedereen die geïnteresseerd is in geschiedenis!&nbsp;</strong><br>Het Historisch Café is een initiatief van <a href="https://www.erfgoedplatformapeldoorn.nl/" target="_blank" rel="noopener noreferrer">Erfgoedplatform Apeldoorn</a> en wordt meerdere keren per jaar georganiseerd in CODA Café. De toegang is gratis. Tijdens het Historisch Café komen diverse thema’s aan bod. In 2026 is er een Historisch Café op:</p></div>
</app-content-panel>

    <p>
  Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh vitae posuere. Morbi sollicitudin, odio sit amet
  bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>
`;

export const wysiwygSimple = `
<p>
      Lorem ipsum dolor sit amet,
      <strong>consectetur</strong>
      adipiscing elit. Quisque eu ligula vitae augue ultrices sollicitudin. Cras dignissim ipsum turpis, quis posuere metus pulvinar sit
      amet. Morbi dictum mi in ultrices dignissim.
      <em>Etiam a tellus in orci luctus laoreet eu quis enim</em>
      . Curabitur ornare augue arcu. Vivamus ut orci dictum,
      <u>pellentesque</u>
      arcu eu, posuere velit.
      <a href="#">Curabitur gravida</a>
      purus elit, non feugiat tortor iacu lis et. Vestibulum facilisis massa a bibendum semper. Nam non imperdiet est. Nam id tincidunt orci.
      Cras auctor aliquet diam, ac dictum nisi venenatis nec. Praesent efficitur porta tellus sit amet accumsan. Etiam tempus interdum nibh
      vitae posuere. Morbi sollicitudin, odio sit amet bibendum ultricies, erat enim cursus felis, ut accumsan turpis tortor nec magna.
    </p>
`;

export const wysiwygSimpleShort = `
<p>
      Lorem ipsum dolor sit amet,
      <strong>consectetur</strong>
      adipiscing elit. Quisque eu ligula vitae augue ultrices sollicitudin.
      <em>Etiam a tellus in orci luctus laoreet eu quis enim</em>.
      <u>pellentesque</u>
      arcu eu, posuere velit.
      <a href="#">Curabitur gravida</a>
      purus elit, non feugiat tortor iaculis et. Vestibulum facilisis massa a bibendum semper. Nam non imperdiet est. Nam id tincidunt orci.
      Cras auctor aliquet diam, ac dictum nisi venenatis nec.
    </p>
`;

// Example events with all possible date combinations
const today = new Date();
export const dateRange = [
  {
    startDate: addDays(today, -1),
    endDate: addDays(today, 1),
  },
  {
    startDate: today,
    endDate: null,
  },
  {
    startDate: addDays(today, 2),
    endDate: addDays(today, 10),
  },
  {
    startDate: addDays(today, 34),
    endDate: null,
  },
  {
    startDate: addYears(today, 1),
    endDate: null,
  },
  {
    startDate: addYears(addDays(today, 2), 1),
    endDate: addYears(addDays(today, 3), 1),
  },
  {
    startDate: addYears(addDays(today, 2), 1),
    endDate: addYears(addDays(today, 20), 1),
  },
];
